export default "__VITE_ASSET__vhdCWpff__"